export default "__VITE_ASSET__d66a9a60__"